module.exports = __webpack_public_path__ + "img/BS05.76e4e143.svg";